(() => {
  const initialize = (root = document) => {
    root.querySelectorAll('[data-friandries-contact-v3]').forEach((form) => {
      if (form.dataset.ready) return;
      form.dataset.ready = 'true';
      const type = form.querySelector('[data-hospitality-type]');
      const other = form.querySelector('[data-hospitality-other]');
      const syncOther = () => {
        if (!type || !other) return;
        const active = type.value === 'Overige';
        other.hidden = !active;
        other.querySelector('input').disabled = !active;
        other.querySelector('input').required = active;
      };
      type?.addEventListener('change', syncOther);
      syncOther();

      const flavors = [...form.querySelectorAll('[data-flavor]')];
      const count = form.querySelector('[data-flavor-count]');
      const syncFlavors = () => {
        const selected = flavors.filter((input) => input.checked).length;
        flavors.forEach((input) => { input.disabled = selected >= 9 && !input.checked; });
        if (count) count.textContent = `${selected} van maximaal 9 smaken gekozen.${selected >= 9 ? ' Deselecteer een smaak om een andere te kiezen.' : ''}`;
      };
      flavors.forEach((input) => input.addEventListener('change', () => {
        if (flavors.filter((flavor) => flavor.checked).length > 9) input.checked = false;
        syncFlavors();
      }));
      syncFlavors();

      const submit = form.querySelector('[type="submit"]');
      const label = submit?.querySelector('span');
      const originalLabel = label?.textContent;
      const restore = () => {
        if (submit) {
          submit.disabled = false;
          submit.removeAttribute('aria-busy');
        }
        if (label) label.textContent = originalLabel;
        syncOther();
        syncFlavors();
      };
      window.addEventListener('pageshow', restore);
      form.addEventListener('submit', (event) => {
        syncOther();
        syncFlavors();
        if (!form.reportValidity() || flavors.filter((input) => input.checked).length > 9) {
          event.preventDefault();
          return;
        }
        // Allow Shopify's spam protection to finish before locking the button.
        setTimeout(() => {
          if (event.defaultPrevented || !submit) return;
          submit.disabled = true;
          submit.setAttribute('aria-busy', 'true');
          if (label) label.textContent = 'Wordt verstuurd…';
          setTimeout(restore, 15000);
        }, 0);
      });
      form.querySelector('.fp-form-status')?.focus();
    });
  };
  initialize();
  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
})();

// The app owns the submitted checkbox values. The theme adds the visual cards.
(() => {
  const selector = '#MainContent:is([data-template="page.proefbox-aanvragen"],[data-template="page.horeca"]) .fc-form-section';
  const observed = new WeakSet();

  const enhance = (section) => {
    const form = section.querySelector('.fc-app-form-block form[data-id="166988"]');
    const imageTemplate = section.querySelector('template[data-friandries-flavor-images]');
    const control = form?.querySelector('[data-element-id="checkbox-1"]');
    if (!form || !control || !imageTemplate) return;

    const images = new Map(
      [...imageTemplate.content.querySelectorAll('[data-slot]')].map((entry) => [entry.dataset.slot, entry.dataset.src])
    );
    const inputs = [...control.querySelectorAll('input[type="checkbox"][name="checkbox-1[]"]')];
    if (!inputs.length) return;

    const list = control.querySelector('fieldset ul.flex-wrap');
    if (list) {
      for (const [prefix, title] of [
        ['Classic', 'Classics'],
        ['Signature', 'Signatures'],
        ['Experimental', 'Experimentals']
      ]) {
        const first = inputs.find((input) => input.value.trim().toLowerCase().startsWith(prefix.toLowerCase() + ' '));
        const card = first?.closest('li');
        let headingItem = list.querySelector('[data-friandries-collection="' + prefix + '"]');
        if (!card) {
          headingItem?.remove();
          continue;
        }
        if (!headingItem) {
          headingItem = document.createElement('li');
          headingItem.className = 'fc-flavor-collection-heading';
          headingItem.dataset.friandriesCollection = prefix;
          const heading = document.createElement('h3');
          heading.textContent = title;
          headingItem.append(heading);
        }
        if (headingItem.nextElementSibling !== card) list.insertBefore(headingItem, card);
      }
    }

    for (const input of inputs) {
      const match = input.value.trim().match(/^(Classic|Signature|Experimental)\s+(0?[1-9]|10)\s*[–—-]\s*(.+)$/i);
      if (!match) continue;
      const slot = `${match[1].toLowerCase()}_${match[2].padStart(2, '0')}`;
      const label = input.nextElementSibling;
      if (!label || label.tagName !== 'LABEL') continue;

      if (label.dataset.fcFlavorSlot !== slot) {
        label.replaceChildren();
        const category = document.createElement('span');
        category.className = 'fc-flavor-category';
        category.textContent = `${match[1]} ${match[2].padStart(2, '0')}`;
        const name = document.createElement('span');
        name.className = 'fc-flavor-name';
        name.textContent = match[3];
        label.append(category, name);
        label.dataset.fcFlavorSlot = slot;
      }

      const url = images.get(slot);
      const current = label.querySelector('.fc-flavor-image');
      if (url) {
        if (!current) {
          const photo = document.createElement('img');
          photo.className = 'fc-flavor-image';
          photo.alt = '';
          photo.loading = 'lazy';
          label.insertBefore(photo, label.querySelector('.fc-flavor-name'));
        }
        const photo = label.querySelector('.fc-flavor-image');
        if (photo.getAttribute('src') !== url) photo.src = url;
      } else {
        current?.remove();
      }
      label.classList.toggle('fc-flavor-has-image', Boolean(url));
    }

    let counter = control.querySelector('[data-friandries-flavor-count]');
    if (!counter) {
      counter = document.createElement('p');
      counter.className = 'fc-flavor-count';
      counter.dataset.friandriesFlavorCount = '';
      counter.setAttribute('aria-live', 'polite');
      control.querySelector('fieldset')?.after(counter);
    }

    const sync = () => {
      const selected = inputs.filter((input) => input.checked).length;
      for (const input of inputs) {
        if (selected >= 9 && !input.checked) {
          if (!input.disabled) {
            input.disabled = true;
            input.dataset.fcLimitDisabled = '';
          }
        } else if (Object.hasOwn(input.dataset, 'fcLimitDisabled')) {
          input.disabled = false;
          delete input.dataset.fcLimitDisabled;
        }
      }
      const message = `${selected} van maximaal 9 smaken gekozen.${selected === 9 ? ' Deselecteer een smaak om een andere te kiezen.' : ''}`;
      if (counter && counter.textContent !== message) counter.textContent = message;
    };

    if (!form.dataset.fcFlavorReady) {
      form.dataset.fcFlavorReady = 'true';
      form.addEventListener('change', (event) => {
        if (!event.target.matches('input[name="checkbox-1[]"]')) return;
        const selected = [...form.querySelectorAll('input[name="checkbox-1[]"]')].filter((input) => input.checked).length;
        if (selected > 9 && event.target.checked) event.target.checked = false;
        enhance(section);
      });
    }
    sync();
  };

  const initialize = (root = document) => {
    root.querySelectorAll(selector).forEach((section) => {
      if (observed.has(section)) return;
      observed.add(section);
      let queued = false;
      const schedule = () => {
        if (queued) return;
        queued = true;
        queueMicrotask(() => {
          queued = false;
          enhance(section);
        });
      };
      new MutationObserver(schedule).observe(section, { childList: true, subtree: true });
      schedule();
    });
  };

  initialize();
  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
})();


// Keep the app's step buttons in the same visual language as the native form.
(() => {
  const selector = '#MainContent:is([data-template="page.proefbox-aanvragen"],[data-template="page.horeca"]) .fc-form-section';
  const observed = new WeakSet();
  const mount = (root = document) => {
    root.querySelectorAll(selector).forEach((section) => {
      if (observed.has(section)) return;
      observed.add(section);
      const sync = () => {
        const arrow = section.querySelector('.fc-native-form-block .fh-button-arrow');
        if (!arrow) return;
        section.querySelectorAll('.fc-app-form-block button.action').forEach((button) => {
          if (!button.querySelector('.fh-button-arrow')) button.append(arrow.cloneNode(true));
        });
      };
      new MutationObserver(sync).observe(section, { childList: true, subtree: true });
      sync();
    });
  };
  mount();
  document.addEventListener('shopify:section:load', (event) => mount(event.target));
})();

// Keep the app navigation arrows independent of the optional native form.
(() => {
  const selector = '#MainContent:is([data-template="page.proefbox-aanvragen"],[data-template="page.horeca"]) .fc-app-form-block';
  const observed = new WeakSet();
  const arrow = document.createElement('span');
  arrow.className = 'fh-button-arrow';
  arrow.setAttribute('aria-hidden', 'true');
  arrow.innerHTML = '<svg width="17" height="7" viewBox="0 0 17 7" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M 0 2.7 L 12.8 2.7 L 11.3 0 L 13.2 0 L 17 3.5 L 13.2 7 L 11.3 7 L 12.8 4.3 L 0 4.3 Z" fill="currentColor"/></svg>';
  const initialize = (root = document) => {
    root.querySelectorAll(selector).forEach((block) => {
      if (observed.has(block)) return;
      observed.add(block);
      const sync = () => {
        block.querySelectorAll('button.action:not(.reset)').forEach((button) => {
          if (!button.querySelector('.fh-button-arrow')) button.append(arrow.cloneNode(true));
        });
      };
      new MutationObserver(sync).observe(block, { childList: true, subtree: true });
      sync();
    });
  };
  initialize();
  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
})();
